var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("this is next component")]),_c('v-btn',{on:{"click":_vm.showCount}},[_vm._v("show count")]),_vm._v(" "+_vm._s(this.$store.state.count)+" "+_vm._s(_vm.localCount)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }